import { ApiService } from 'networking/api-service';
import { API_ROUTES } from 'networking/api-routes';
import { VaultsSerializer } from 'networking/serializers/vaults-serializer';

class GuestsController {
  static async getGuestInfo() {
    const response = await ApiService.get<GuestRaw>(API_ROUTES.GUEST_INFO);
    return VaultsSerializer.deSerializeGuestInfo(response.data);
  }
}

export { GuestsController };
